import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("Verifying...");
  const [showPopup, setShowPopup] = useState(false);
  const [success, setSuccess] = useState(false);

  const email = searchParams.get("email");
  const token = searchParams.get("token");

  useEffect(() => {
    const verify = async () => {
      try {
        const res = await axios.get(
          `https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/email/confirm?email=${email}&token=${token}`,
          {
            validateStatus: () => true, // don’t auto-throw
          }
        );

        console.log("📩 Backend response:", res); // 👀 see status + data

        if (res.status === 200 || res.status === 204 || res.data?.isVerified) {
          setStatus("Email verified successfully! You can now create acount");
          setSuccess(true);
        } else {
          setStatus("❌ Verification failed. Link may be invalid or expired.");
          setSuccess(false);
        }
      } catch (err) {
        console.error("❌ Unexpected error:", err);
        setStatus("❌ Verification failed. Link may be invalid or expired.");
        setSuccess(false);
      } finally {
        setShowPopup(true);
      }
    };

    if (email && token) {
      verify();
    } else {
      setStatus("❌ Invalid verification link.");
      setSuccess(false);
      setShowPopup(true);
    }
  }, [email, token]);

  const handleClose = () => setShowPopup(false);

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      {showPopup && (
        <div
          style={{
            display: "inline-block",
            padding: "20px 30px",
            borderRadius: "12px",
            backgroundColor: success ? "#d4edda" : "#f8d7da",
            color: success ? "#155724" : "#721c24",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            marginTop: "50px",
            maxWidth: "400px",
          }}
        >
          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>{status}</h2>
          <button
            onClick={handleClose}
            style={{
              marginTop: "10px",
              padding: "10px 20px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              fontWeight: "bold",
              backgroundColor: success ? "#28a745" : "#dc3545",
              color: "#fff",
            }}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
}
